import React, { useState, useEffect, useContext } from "react";
import ModelContext from "../ModelContext";
import useMediaQuery from '@mui/material/useMediaQuery';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

import "./imagegallery-swiper-styles.css";

export const ImageGallery = (props) => {
    const modelCtx = useContext(ModelContext);
    const [numSlides, setNumSlides] = useState(2);
    const [centerSlide, setCenterSlide] = useState(false);
    const [isAdjustment, setIsAdjustment] = useState(true);

    const isMobile = useMediaQuery('(max-width:480px)');
    const isTablet = useMediaQuery('(max-width:1024px)'); 
    const isTabletH = useMediaQuery('(max-width:1280px)'); 
    const isLaptop = useMediaQuery('(max-width:1440px)'); 

    const [images, setImages] = useState([{
        filE_NAME: "",
        flaG_FG: false,
        flaG_FGA: false,
        fullpatH_FILE_NAME: "",
        layouT_GROUP_ID: 0,
        layouT_GROUP_LANGUAGES_DESCRIPTION: "",
        mediA_CONTENT_SORTING: 0,
        tags: "",
        tagS_DESCRIPTION: "",
        templateS_DESCRIPTION: "",
        updatE_DATE: "",
        url: ""
    }]);

    useEffect(() => {
        const getImages = async () => {

            const input = modelCtx.inputModelData;

            if (input.idBasicModel !== 0) {
                let pathUrl = "/api/model/photogallery";
                switch (props.gallery) {
                    case "external":
                        pathUrl += "/external";
                        if (isMobile || isTablet) {
                            setNumSlides(1);
                        }
                        break;
                    case "internal":
                        pathUrl += "/internal";
                        if (isMobile || isTablet || isTabletH || isLaptop) {
                            setNumSlides(1);
                        } else {
                            setNumSlides("auto");
                            setIsAdjustment(false);
                        }
                        setCenterSlide(true);
                        
                        break;
                    default:
                        break;
                }

                if (props.template !== "") {
                    pathUrl += "/" + props.template;
                }

                const response = await fetch(pathUrl, {
                    method: 'POST',
                    body: JSON.stringify(input),
                    headers: { 'Content-Type': 'application/json' }
                });


                if (response.ok) {
                    const data = await response.json();
                    if (data) {
                        setImages(data);
                    }
                } else {
                    // Error
                }
            }
        }
        getImages();
    }, [modelCtx.inputModelData]);


    return (
        <div className="image-gallery-position">
            <Swiper
                modules={[Navigation, Pagination, Scrollbar, A11y]}
                spaceBetween={10}
                slidesPerView={numSlides}
                centeredSlides={centerSlide}
                navigation
                pagination={{ type: "fraction" }}
            >

                {images.map((image, i) => (
                    <SwiperSlide key={i}>
                        <div className="text-center">
                            {isAdjustment &&
                                <>
                                <img src={image.fullpatH_FILE_NAME}
                                    alt={image.tags} className="imagegallery-img-item-width" />
                                <p className="text4">{image.tags}</p>
                                </>
                            }

                            {!isAdjustment &&
                                <>
                                <img src={image.fullpatH_FILE_NAME}
                                    alt={image.tags} className="imagegallery-img-item-height" />
                                <p className="text4">{image.tags}</p>
                                </>
                            }

                            </div>
                    </SwiperSlide>
                ))}

            </Swiper>
        </div>
    );
};

export default ImageGallery;
